import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiAuthService } from './api-auth.service';
import { isNullOrUndefined, isNull } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ApiRegistryService {
  private headers: HttpHeaders;

  constructor(public globals: Globals, private httpApi: HttpClient, private apiAuth: ApiAuthService) { }

  preRegistro(rfc: string, correo: string, password: string, celular: string,tipo?:string) {
    let httpParams = new HttpParams()
    .append("rfc", rfc)
    .append("email", correo)
    .append("password", password)
    .append("url", this.globals.BASE_URL_VERIFICA)
    .append("celular", celular)
    .append("vps_tipo", tipo);

    return this.httpApi.post(this.globals.BASE_URL + 'preregistro_E', httpParams)
            .pipe(map(data => data));
  }

  registro(datosGen, representantes, domicilioFis, contacto, datosBanco) {
    this.actualizaHeader();
            let httpParams = new HttpParams()
                .append("vpn_pk_fkcprco", datosGen.folio)
                .append("vps_rfc", datosGen.rfc)
                .append("vps_nombcom", datosGen.nombcom)
                .append("vps_pk_fkcpers", datosGen.pk_fkcpers)
                .append("vps_nombre", datosGen.nombre)
                .append("vps_apepat", datosGen.apepat)
                .append("vps_apemat", datosGen.apemat)
                .append("vps_razsoc", datosGen.razsoc)
                .append("vpn_giro",datosGen.giro)
                .append("vps_activ_emp", datosGen.activEmp)
                .append("vps_estratifica", datosGen.estratifi)
                .append("vps_calle", domicilioFis.calle)
                .append("vps_numext", domicilioFis.numeroExt)
                //.append("vps_numint", domicilioFis.numeroInt)
                .append("vps_colonia", domicilioFis.colonia)
                .append("vpn_cp", domicilioFis.cp)
                .append("vps_tel1", domicilioFis.tel1)
                .append("vps_tel2", '')
                .append("vps_curp", datosGen.curp)
                .append("vpn_origen", '1')
                .append("vpn_pais", datosGen.pais)
                .append("vps_pk_fkcpers_rl", representantes.pk_fkcpers_rl)
                .append("vps_curp_rl", representantes.curpReprLegal)
                .append("vps_nombre_rl", representantes.nomReprLegal)
                .append("vps_apepat_rl", representantes.apepatReprL)
                .append("vps_apemat_rl", representantes.apematReprL)
                .append("vps_telefono_rl", representantes.telefono_rl)
                .append("vps_telcel_rl", representantes.telcel_rl)
                .append("vps_correo_rl", representantes.correo_rl)
                .append("vps_pk_fkcpers_rt", representantes.pk_fkcpers_rt)
                .append("vps_curp_rt", representantes.curpReprTec)
                .append("vps_nombre_rt", representantes.nomReprTec)
                .append("vps_apepat_rt", representantes.apepatReprT)
                .append("vps_apemat_rt", representantes.apematReprT)
                .append("vps_telefono_rt", representantes.telefono_rt)
                .append("vps_telcel_rt", representantes.telcel_rt)
                .append("vps_correo_rt", representantes.correo_rt)
                .append("vps_pk_fkcpers_ct", contacto.pk_fkcpers_ct)
                .append("vps_curp_ct", contacto.curp)
                .append("vps_nombre_ct", contacto.nombre)
                .append("vps_apepat_ct", contacto.apepat)
                .append("vps_apemat_ct", contacto.apemat)
                .append("vps_telefono_ct", contacto.telef)
                .append("vps_telcel_ct", contacto.movil)
                .append("vps_correo_ct", contacto.correo)
                .append("vps_cedula", datosGen.noCedPadEst)
                .append("vps_correo_emp", contacto.correoEmp)
                .append("vps_indfiscal", datosGen.indfis)
                .append("vps_indtipo", datosGen.indtip)
                .append("vpn_pk_fcccuba", datosBanco.fcccuba)
                .append("vps_cuenta", datosBanco.cuenta)
                .append("vps_clabe", datosBanco.cuentaClabe)
                .append("vpn_pk_banco", datosBanco.banco)
                .append("vpn_subcontrata", datosGen.subcontrat)
                .append("vps_indvial", domicilioFis.vialidad)
                .append("vps_indpleg", datosGen.representante);
                //.append("vps_pagweb", contacto.paginaweb);

                if (!isNullOrUndefined(domicilioFis.numeroInt))    {httpParams = httpParams.append("vps_numint", domicilioFis.numeroInt)}
                if (!isNullOrUndefined(contacto.paginaweb))    {httpParams = httpParams.append("vps_pagweb", contacto.paginaweb)}

                if (!isNullOrUndefined(datosGen.gradoEstudio))    {httpParams = httpParams.append("vps_gradoest", datosGen.gradoEstudio)}

                if (!isNullOrUndefined(datosGen.estado))    {httpParams = httpParams.append("vps_estado", datosGen.estado)}
                if (!isNullOrUndefined(datosGen.ciudad))    {httpParams = httpParams.append("vps_ciudad", datosGen.ciudad)}
                if (!isNullOrUndefined(datosGen.fechaNac))    {httpParams = httpParams.append("vps_fecnac", datosGen.fechaNac)}
                if (!isNullOrUndefined(datosGen.sexo))    {httpParams = httpParams.append("vps_sexo", datosGen.sexo)}
                if (!isNullOrUndefined(datosGen.ciudadDesc))    {httpParams = httpParams.append("vps_ciudaddescri", datosGen.ciudadDesc)}
                if (!isNullOrUndefined(datosGen.cedula))    {httpParams = httpParams.append("vps_numcedula", datosGen.cedula)}

            return this.httpApi.post(this.globals.BASE_URL + 'registro_E', httpParams, {headers: this.headers})
                   .pipe(map(data => data));

  }

  getLovs(cveLov: string, parametros?: string) {
    if (isNullOrUndefined(parametros)){
      parametros = '';
    }
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL_UTILERIAS + `obtenerDatosLovs_E?cveLov=${ cveLov }&parametros=${parametros}`, { headers: this.headers})
                .pipe(map(data => data));
  }

  getEstratificacion(tabla: string, campo: string) {
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL_UTILERIAS + `obtenerIndicadores_E?tabla=${ tabla }&campo=${ campo }`, { headers: this.headers})
                .pipe(map(data => data));
  }

  getCodigoPostal(codigoPostal: string) {
    console.log('A');
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL + `obtenerPorCp_E?cp=${ codigoPostal }`, { headers: this.headers})
                .pipe(map(data => data));
  }


  getPersonaCurp(curp: string) {
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL + `getPersonaCurp_E?curp=${ curp }`, { headers: this.headers})
                .pipe(map(data => data));
  }

  getInformacionRfc(rfc: string) {
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL + `getInfoProveedor_E?rfc=${ rfc }`, { headers: this.headers})
                .pipe(map(data => data));
    /*let httpParams = new HttpParams()
                .append("rfc", rfc);

    return this.httpApi.post(this.globals.BASE_URL + 'getInfoProveedor_E', httpParams, {headers: this.headers,})
                .pipe(map(data => data));*/


  }

  getIndicadores(tabla: string, campo: string) {
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL_UTILERIAS + `obtenerIndicadores_E?tabla=${ tabla }&campo=${ campo }`, { headers: this.headers })
                .pipe(map(data => data));
  }



  getPlantillaDoc(correo: string, proveedor: string) {
    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL + `ObtenerPlantillaDoc_E?idUsuario=${ correo }&vpn_proveedor=${ proveedor }`, { headers: this.headers})
                .pipe(map(data => data));
  }

  finalizaCaptura(vpnCveprov: string, correo: string) {
    this.actualizaHeader();
    let httpParams = new HttpParams()
    .append("vpn_cveprov", vpnCveprov)
    .append("email", correo);
    return this.httpApi.post(this.globals.BASE_URL + 'finalizaCaptura_E', httpParams, {headers: this.headers})
            .pipe(map(data => data));
  }

  private actualizaHeader() {
    let token = this.apiAuth.getToken() !== null ? this.apiAuth.getToken().replace(/["\\]/g, '') : '';
    token = token.replace(/["\\]/g, '');
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      "Authorization": `Bearer ${token}`
    });
  }

  enviarCorreos(idProveedor: string, anio: string, idProcedimiento: string, mensaje: string, asunto : string) {
    this.actualizaHeader();
    return this.httpApi.post(this.globals.BASE_URL + `enviaCorreoGenerico?proveedor=${ idProveedor }&procedimiento=${ idProcedimiento }&anio=${ anio }&correo_asunto=${asunto}&mensaje=${mensaje}`, {headers: this.headers})
                .pipe(map(data => data));
  }

  getEdoRegistro(vps_tipo:string) {

    this.actualizaHeader();
    return this.httpApi.get(this.globals.BASE_URL_UTILERIAS + `api/fun_ObtEstadoPeriodo_E?VPS_TipoTramite=${ vps_tipo }`,  { headers: this.headers})
                .pipe(map(data => data ));
}

}
